import template from './sw-seo-url.html.twig';

const { Component } = Shopware;

Component.extend('acris-faq-seo-url', 'sw-seo-url', {
    template,

    props: {
        isInputDisabled: {
            type: Boolean,
            default: false,
        },

        copyable: {
            type: Boolean,
            default: false,
        },
    }
});
